import cx from 'classnames';

import { CloseNewIcon } from 'components/Icon';

import styles from './EventNotAvailableForPublic.module.scss';

export type EventNotAvailableForPublicProps = {
  isUzbekITTV?: boolean;
  onPurchase?(): void;
};

const EventNotAvailableForPublic = ({ isUzbekITTV, onPurchase }: EventNotAvailableForPublicProps) => {
  // TODO: Find another solution for uzbekittv channel custom buttons
  const title = isUzbekITTV ? 'Ushbu kontent faqat pullik obunachilar uchun' : 'This content is not available for you';
  const message = isUzbekITTV
    ? "Uni tomosha qilish uchun, iltimos, obuna bo'ling"
    : 'Please purchase membership plan to get access to this event';
  const purchaseText = isUzbekITTV ? "Obuna bo'lish" : 'Become a member';

  return (
    <div className={styles.container}>
      <CloseNewIcon />
      <h3>{title}</h3>
      <p>{message}</p>
      <div className={styles.actions}>
        <button type="button" className={cx(styles.action, styles.purchase)} onClick={onPurchase}>
          {purchaseText}
        </button>
      </div>
    </div>
  );
};

export default EventNotAvailableForPublic;
